import {Object3D} from 'three';
import {store} from 'store/customer/storeSetup';
import {CabinetMesh} from 'components/customer/RoomPlanner/types';
import {updateCabinetPosition} from 'components/customer/RoomPlanner/store/roomPlannerSlice';

/**
 * Parameters used to reposition a cabinet based on wall dimension changes.
 */
export interface RepositionCabinetParams {
    product: Object3D;
    wallDifferenceLength?: number;
    wallDifferenceWidth?: number;
    oldPositionX?: React.MutableRefObject<number>;
    oldPositionZ?: React.MutableRefObject<number>;
}

/**
 * Repositions a cabinet along the X direction.
 *
 * @param {THREE.Object3D} baseProduct - The cabinet Object3D to reposition
 * @param {number} wallDifferenceWidth - Difference in wall width used to offset the cabinet
 * @param {number} wallDifferenceLength - Difference in wall length used to offset the cabinet
 */
export function repositionCabinetDirection({
    product,
    wallDifferenceWidth = 0,
    wallDifferenceLength = 0,
    oldPositionX,
    oldPositionZ,
}: RepositionCabinetParams) {
    if (oldPositionX?.current != null) {
        product.position.x = oldPositionX.current;
    }

    if (oldPositionZ?.current != null) {
        product.position.z = oldPositionZ.current;
    }
    product.position.set(
        product.position.x - wallDifferenceWidth,
        product.position.y,
        product.position.z - wallDifferenceLength
    );

    const id = Number((product as CabinetMesh).userData?.values?.id ?? 0);

    let index = 0;
    if (
        typeof product.userData?.id === 'string' ||
        typeof product.userData?.id === 'number'
    ) {
        [, index] = String(product.userData.id)
            .split('-')
            .map((val) => Number(val));
    }

    store.dispatch(
        updateCabinetPosition({
            rotation: product.rotation,
            position: product.position,
            id,
            index,
        })
    );
}
